import script from "./CompanyEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyEvent.vue?vue&type=script&setup=true&lang=js"

import "./CompanyEvent.vue?vue&type=style&index=0&id=0294bfee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0294bfee"]])

export default __exports__